import {Ed25519KeyIdentity} from '@dfinity/identity';
import {BackendActor} from '../lib/agent';

export function getBackend(identity: Ed25519KeyIdentity) {
  return BackendActor.getBackendActor(identity);
}
